import { render, staticRenderFns } from "./PackageDialog.vue?vue&type=template&id=e0fe7974&"
import script from "./PackageDialog.vue?vue&type=script&lang=js&"
export * from "./PackageDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports